import { Dispatch, SetStateAction } from 'react';
import styles from './style.module.scss';

interface Props {
    value: string;
    label?: string;
    isRequired?: boolean;
    onChange: (val: string) => void;
};

function TextArea(props: Props) {
    const { label, value, isRequired, onChange } = props;

    return (
        <div className={styles.wrapper}>
            {label && <label htmlFor="text_area">{label} {isRequired && <b>*</b>}</label>}
            <textarea
                name="text_area"
                value={value}
                onChange={e => onChange(e.target.value)}
            />
        </div>
    )
}

export default TextArea;
